import { initDisplay } from './display';
import { MonoBehavior } from './monoBehavior';
import { App } from './pixiRenderer';
import { initFileStyle } from '../gameUI/fileStyle';

export class GameClass {
    isPlaying: boolean;
    gameObjectsList: MonoBehavior[];
    isStarted = false;

    constructor() {
        this.mainLoop = this.mainLoop.bind(this);
        this.isPlaying = false;
        this.gameObjectsList = [] as MonoBehavior[];
    }
    start() {
        initDisplay();
        initFileStyle();
        App.app.ticker.add(this.mainLoop);
    }

    addGameObject(go: MonoBehavior) {
        this.gameObjectsList.push(go);
    }
    removeGameObject(id: string) {
        this.gameObjectsList = this.gameObjectsList.filter((go) => go._id !== id);
    }
    mainLoop() {
        this.gameObjectsList.forEach((go) => {
            if (!go._isStarted) {
                go.startGameObject();
            }
        });

        this.gameObjectsList.forEach((go) => {
            if (go._isActive && go._update) {
                go.update();
            }
        });
    }
}

export const Game = new GameClass();
